import styled from 'styled-components/macro';
import colors from 'Common/constants/colors';
import CommonBox from 'Common/components/Boxes/CommonBox';

const OuterBox = styled(CommonBox)`
    background: ${colors.OUTER_BOX_BACKGROUND};
`;

export default OuterBox;
